function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m834.77 384.95 230.89 33.277c65.473 9.4336 91.703 89.855 44.398 136.08l-166.86 163.02c-18.793 18.359-27.336 44.785-22.871 70.668l39.707 229.87c11.258 65.184-57.109 114.98-115.7 84.277l-206.61-108.3c-23.27-12.191-51.047-12.168-74.281 0.085937l-206.35 108.8c-58.512 30.852-127.01-18.793-115.91-84l39.156-229.97c4.4023-25.895-4.1992-52.309-23.039-70.621l-167.22-162.62c-47.426-46.117-21.383-126.6 44.074-136.19l230.81-33.816c25.992-3.8047 48.445-20.16 60.035-43.727l103-209.32c29.207-59.352 113.8-59.461 143.14-0.16797l103.49 209.06c11.652 23.531 34.141 39.84 60.145 43.586z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.44cef12ba13836f29b20b481a75b4b5a.svg";
export { ForwardRef as ReactComponent };